@if(showAlert) {
  <app-alert-modal [isSuccess]="isSuccess" [showIcon]="!isConfirm" [hasButtons]="isConfirm" [txtConfirmButton]="'Aceptar'"
    [message]="messageAlert" [isHtml]="true" (onCancel)="showAlert=false;resetModal()" (onConfirm)="showAlert=false;resetModal()">
  </app-alert-modal>
}

@if(isSaving || isLoading) {
  <div class="bg-slate-800/50 dark:bg-black/70 flex justify-center items-center fixed inset-0 z-40">
    <app-loader [message]="messageLoading"></app-loader>
  </div>
}

@if(openModal) {
  <app-confirm-request [isResponse]="!isConfirm" [hasButtons]="isConfirm" [txtConfirmButton]="'Aceptar'"
    [showIcon]="true" [isSuccess]="isSuccess" [isHtml]="isHTML" [message]="messageModal"
    (onCancel)="openModal=false;resetModal()" (onConfirm)="sendRequestToPrint($event)">
  </app-confirm-request>
}

<div class="p-5">
  <!-- Filters -->
  <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 mb-3">
    <p-iconfield>
      <p-inputicon styleClass="pi pi-search" />
      <input pInputText type="text" [(ngModel)]="searchTxt" placeholder="Buscar..." (keyup)="searchByText($event)" class="w-full sm:w-64" />
    </p-iconfield>

    <p-selectbutton [options]="statusOptions" [(ngModel)]="statusFilter" optionLabel="label" optionValue="value" (onChange)="onStatusFilterChange()" [allowEmpty]="false" />

    <p-select [options]="groups" [(ngModel)]="groupFilter" optionLabel="description" optionValue="groupId"
      placeholder="Todos los grupos" [showClear]="true" (onChange)="onGroupFilterChange()" class="w-full sm:w-52" />
  </div>

  <!-- Actions -->
  <div class="flex flex-wrap items-center gap-2 mb-4">
    @if(!showPrintColumn) {
      @if(data.UserType === 'Administrator' || data.UserType === 'Modify') {
        @if(changedCards.length > 0) {
          <button pButton label="Guardar Cambios" class="p-button-sm" (click)="saveChangedDevices()"></button>
        }
        @if(changedCards.length === 0) {
          <button pButton label="Solicitar Reimpresión" class="p-button-sm p-button-outlined" (click)="showPrintColumn=true"></button>
        }
      }
    }
    @if(showPrintColumn) {
      <button pButton label="Enviar" class="p-button-sm" [disabled]="selectedCardsForPrint.length === 0" (click)="openModalToPrint()"></button>
      <button pButton label="Cancelar" class="p-button-sm p-button-outlined" (click)="showPrintColumn=false;selectedCardsForPrint=[]"></button>
    }
    @if(showRenewColumn) {
      <button pButton label="Renovar seleccionadas" class="p-button-sm" [disabled]="selectedCardsForRenew.length === 0" (click)="confirmBatchRenew()"></button>
      <button pButton label="Cancelar" class="p-button-sm p-button-outlined" (click)="showRenewColumn=false;selectedCardsForRenew=[]"></button>
    }
    @if((data.UserType === 'Administrator' || data.UserType === 'Modify') && !showPrintColumn && !showRenewColumn && changedCards.length === 0) {
      <button pButton label="Nuevo Dispositivo" class="p-button-sm" (click)="addDevice()"></button>
      @if(expiringCards.length > 0) {
        <button pButton label="Renovar vigencias" icon="pi pi-refresh" class="p-button-sm p-button-outlined" (click)="showRenewColumn=true"></button>
        <span class="rounded-md p-2 bg-red-100 text-red-900 text-sm"> Se encuentran expirados {{expiringCards.length}} dispositivos </span>
      }
    }
    <div class="ml-auto flex items-center gap-2">
      <button pButton icon="pi pi-file-excel" class="p-button-sm p-button-outlined" (click)="downlolad('XLS')" pTooltip="Descargar XLS"></button>
      <button pButton icon="pi pi-file-pdf" class="p-button-sm p-button-outlined" (click)="downlolad('PDF')" pTooltip="Descargar PDF"></button>
    </div>
  </div>

  <!-- Desktop Table -->
  <div class="hidden md:block">
    <p-table
      [value]="filteredTable"
      [paginator]="filteredTable.length > rowsPerPage"
      [rows]="rowsPerPage"
      [rowsPerPageOptions]="[10, 50, 100]"
      [scrollable]="true"
      scrollHeight="flex"
      styleClass="p-datatable-sm p-datatable-striped"
      [showCurrentPageReport]="true"
      [currentPageReportTemplate]="'Mostrando {first} a {last} de {totalRecords}'"
      selectionMode="single"
      (onRowSelect)="getItem($event.data)"
    >
      <ng-template #header>
        <tr>
          <th class="w-[140px]">
            <div class="flex flex-col items-center gap-1">
              <span>Status</span>
              @if(data.UserType === 'Administrator' || data.UserType === 'Modify') {
                <p-toggleswitch [(ngModel)]="statusAll" (onChange)="changeAllStatus($event.checked)" />
              }
            </div>
          </th>
          @for(col of headers; track col.key) {
            <th [pSortableColumn]="col.key">
              {{ col.textHeader }}
              <p-sortIcon [field]="col.key" />
            </th>
          }
          <th pSortableColumn="expirationDate">
            Vigencia
            <p-sortIcon field="expirationDate" />
          </th>
          @if(showRenewColumn) {
            <th class="w-[120px] text-center">
              <input type="checkbox" [checked]="selectedCardsForRenew.length === expiringCards.length && expiringCards.length > 0"
                (change)="selectAllForRenew($any($event.target).checked)" />
            </th>
          }
          @if(showPrintColumn) {
            <th class="w-[120px] text-center">Reimpresión</th>
          }
        </tr>
      </ng-template>

      <ng-template #body let-item>
        <tr>
          <td class="text-center">
            @if(data.UserType === 'Administrator' || data.UserType === 'Modify') {
              <p-toggleswitch [ngModel]="getStatusModel(item)" (onChange)="onSwitchChange($event.checked, item)" />
            } @else if(data.UserType === 'Review') {
              {{ item.cardStatus === 'I' ? 'Inactiva' : 'Activa' }}
            } @else {
              <span class="px-2 py-1 rounded-md text-xs font-semibold"
                [ngClass]="{'bg-green-100 text-green-700': item.cardStatus === 'A', 'bg-red-100 text-red-700': item.cardStatus === 'I'}">
                {{ item.cardStatus === 'I' ? 'Inactiva' : 'Activa' }}
              </span>
            }
          </td>
          @for(col of headers; track col.key) {
            <td class="cursor-pointer" (click)="getItem(item)">{{ item[col.key] }}</td>
          }
          <td class="text-center whitespace-nowrap">
            @if(isExpired(item)) {
              <span class="px-2 py-0.5 rounded-full text-xs font-semibold bg-red-100 text-red-700">Vencida</span>
            } @else if(isExpiringSoon(item)) {
              <span class="px-2 py-0.5 rounded-full text-xs font-semibold bg-yellow-100 text-yellow-700">Por vencer</span>
            } @else {
              <span class="text-sm">{{ item.expirationDate | date:'dd/MM/yyyy' }}</span>
            }
            @if((isExpired(item) || isExpiringSoon(item)) && (data.UserType === 'Administrator' || data.UserType === 'Modify')) {
              <button pButton icon="pi pi-refresh" class="p-button-rounded p-button-text p-button-sm ml-1"
                pTooltip="Renovar vigencia" (click)="$event.stopPropagation(); renewCard(item)">
              </button>
              
            }
          </td>
          @if(showRenewColumn) {
            <td class="text-center">
              @if(isExpired(item) || isExpiringSoon(item)) {
                <input type="checkbox" [checked]="isSelectedForRenew(item)" (change)="toggleRenewSelection(item)" (click)="$event.stopPropagation()" />
              }
            </td>
          }
          @if(showPrintColumn) {
            <td class="text-center">
              @if(item.deviceType === 'UP' && item.cardStatus === 'A' && (item.vehicleType === 'HQR' || item.vehicleType === 'TV') && !item.isAppEnabled) {
                <button pButton [icon]="isSelected(item) ? 'pi pi-check-circle' : 'pi pi-circle'"
                  [class]="isSelected(item) ? 'p-button-rounded p-button-success p-button-text' : 'p-button-rounded p-button-secondary p-button-text'"
                  (click)="selectItemForPrint(item)">
                </button>
              }
            </td>
          }
        </tr>
      </ng-template>

      <ng-template #emptymessage>
        <tr>
          <td [attr.colspan]="headers.length + 2 + (showPrintColumn ? 1 : 0) + (showRenewColumn ? 1 : 0)" class="text-center py-8">
            {{ emptyTableMessage }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Mobile Cards -->
  <div class="md:hidden space-y-3">
    @if(filteredTable.length > 0) {
      @for(item of filteredTable; track item.cardId) {
        <div class="bg-white dark:bg-crayola-blue-800 rounded-lg shadow-sm p-4 space-y-2 cursor-pointer" (click)="getItem(item)">
          <div class="flex items-center justify-between">
            <span class="font-bold text-vivid-royal-800 dark:text-white">{{ item.vehicleFullNumber }}</span>
            <div class="flex items-center gap-2">
              <span class="px-2 py-0.5 rounded-full text-xs font-semibold"
                [ngClass]="item.cardStatus === 'A' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'">
                {{ item.cardStatus === 'A' ? 'Activo' : 'Inactivo' }}
              </span>
              @if(data.UserType === 'Administrator' || data.UserType === 'Modify') {
                <p-toggleswitch [ngModel]="getStatusModel(item)" (onChange)="$event.originalEvent.stopPropagation(); onSwitchChange($event.checked, item)" />
              }
              <i class="pi pi-chevron-right text-vivid-royal-300 text-sm"></i>
            </div>
          </div>
          @if(getGroupName(item); as gName) {
            <div class="flex items-center gap-1 text-xs text-vivid-royal-400">
              <i class="pi pi-folder text-vivid-royal-300"></i>
              <span>{{ gName }}</span>
            </div>
          }
          <div class="grid grid-cols-2 gap-x-4 gap-y-1 text-sm">
            <div class="text-vivid-royal-400">Usuario</div>
            <div class="text-right text-vivid-royal-900 dark:text-white">{{ item.nameUser }}</div>
            <div class="text-vivid-royal-400">Vehículo</div>
            <div class="text-right text-vivid-royal-900 dark:text-white">{{ item.description }}</div>
            <div class="text-vivid-royal-400">Placas</div>
            <div class="text-right text-vivid-royal-900 dark:text-white">{{ item.plates }}</div>
          </div>
        </div>
      }
    } @else {
      <p class="text-center py-8 text-vivid-royal-400">{{ emptyTableMessage }}</p>
    }
  </div>
</div>

<!-- Renew expiration dialog -->
<p-dialog header="Renovar vigencia" [(visible)]="showRenewDialog" [modal]="true" [style]="{width: '420px'}" [closable]="true">
  <div class="space-y-3">
    <div class="flex items-center gap-3">
      <i class="pi pi-exclamation-triangle text-2xl text-mustard-600"></i>
      <p class="text-sm text-vivid-royal-700 dark:text-dark-khaki-50">
        @if(renewingCard) {
          ¿Desea renovar la vigencia del dispositivo <strong>{{ renewingCard?.vehicleFullNumber }}</strong> por 4 años?
        } @else {
          ¿Desea renovar la vigencia de <strong>{{ selectedCardsForRenew.length }}</strong> tarjeta(s) por 4 años?
        }
      </p>
    </div>
  </div>
  <ng-template #footer>
    <button pButton label="Cancelar" class="p-button-text" (click)="showRenewDialog=false"></button>
    <button pButton label="Renovar" icon="pi pi-refresh" [disabled]="renewing" (click)="confirmRenew()">
      @if(renewing) { <i class="pi pi-spin pi-spinner ml-2"></i> }
    </button>
  </ng-template>
</p-dialog>
